export default __webpack_public_path__ + "locales/pt/Errors.json?hash=b8ca390ae6606c9b8769d19f3312cb32";